/**
 * This module manages the snackbar
 *
 * @file
 * @author DJ Kim <dj@thebrandingfarm.com>
 */

import {
    VUEX_SNACKBAR_SHOW,
    VUEX_SNACKBAR_AUTO_HIDE,
    VUEX_SNACKBAR_CLICK_HIDE,
    VUEX_SNACKBAR_HIDE
}   from '@/store/constants/snackbar'

const state = {
    show: false,

    timeout: 4000,                  //how long to show the confirmation, in miliseconds | Recommended: 4000 no button, 6000 button, 0 permanent
    description_text: '',           //the text on the left of the button
    button_text: '',                //if blank, button is hidden
    button_dispatch: '',            //if blank, button will close.  if not blank, it will dispatch the text
    button_dispatch_payload: {},    //payload to pass into dispatch | default {}

}
const actions = {
    //open is dispatched
    [VUEX_SNACKBAR_SHOW]: ({commit}, payload) => {
        commit(VUEX_SNACKBAR_SHOW, payload)
    },

    //user clicks hide
    [VUEX_SNACKBAR_CLICK_HIDE]: async ({commit, state, dispatch}) => {
        if (state.button_dispatch !== '') {
            dispatch(state.button_dispatch, {name:state.button_dispatch_payload})
        }
        commit(VUEX_SNACKBAR_HIDE)
    },

    //autohide occurs
    [VUEX_SNACKBAR_AUTO_HIDE]: ({commit}) => {
        commit(VUEX_SNACKBAR_HIDE)
    }
}

const mutations = {
    [VUEX_SNACKBAR_SHOW]: (state, payload) => {
        state.timeout = payload.timeout
        state.description_text = payload.description_text
        state.button_text = payload.button_text
        state.button_dispatch = payload.button_dispatch
        state.button_dispatch_payload = payload.button_dispatch_payload

        state.show = true
    },
    [VUEX_SNACKBAR_HIDE]: (state) => {
        state.show = false;
    }
}

/**
 * The Snackbar module of our Vuex store.
 * @module store/modules/snackbar
 */
export default {
    state,
    actions,
    mutations,
}
